import { render, staticRenderFns } from "./RecipeLabelDifficulty.vue?vue&type=template&id=dc94fd86&"
import script from "./RecipeLabelDifficulty.vue?vue&type=script&lang=js&"
export * from "./RecipeLabelDifficulty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports